import { jsxs as s, jsx as o } from "react/jsx-runtime";
import { GroceriesShopping as r } from "../../../assets/svgs/GroceriesShopping.js";
const i = () => /* @__PURE__ */ s("section", { className: "change-order-no-similar-products", children: [
  /* @__PURE__ */ o("h3", { className: "no-similar-title", children: "Nesse momento este produto não possui um substituto automático!" }),
  /* @__PURE__ */ o(r, {})
] });
export {
  i as NoSimilarProduct
};
